import Paper from '@mui/material/Paper';

import {  styled } from '@mui/material/styles';

export const Container = styled(Paper)(() => ({
  minWidth: 150,
  padding: 16,
  display: 'flex',
  alignItems: 'baseline',
  flexDirection: 'column',

  '> strong': {
    fontSize: '1.125rem',
  },
}));
